/**
 * @module FE-CU14_警報確認画面_センサー
 */
import Header from '../../../../components/header/Header.vue';
import BreadCrumbList from '../../../../components/breadCrumb/List.vue';
import AlertConfirmation from './components/AlertConfirmation.vue';
import MobileFooter from '../../../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../../../components/pcPageTitle/PcPageTitle.vue';
import CONSTANTS from '../../../../constants';

const PAGE_ID = 'FE-CU14';

export default {
  name: 'AlertConfirmSensor',
  components: {
    Header,
    BreadCrumbList,
    AlertConfirmation,
    MobileFooter,
    PcPageTitle,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU14警報確認画面センサー.警報確認センサー'),
      from: '',
      panelTitle: {
        place: '',
        type: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      },
      displayAreaList: [
        {
          id: 1,
          title: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.利用プラン',
          text: '',
        },
        {
          id: 2,
          title: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.お客様番号',
          text: '',
        },
        {
          id: 3,
          title: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.警備先名',
          text: '',
        },
        {
          id: 4,
          title: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.地区番号',
          text: '',
        },
        {
          id: 5,
          title: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.地区名',
          text: '',
        },
      ],
      planCode: [
        '$vuetify.コード.利用プランID.オンライン監視プラン',
        '$vuetify.コード.利用プランID.依頼かけつけプラン',
        '$vuetify.コード.利用プランID.依頼かけつけプラン',
        '$vuetify.コード.利用プランID.セルフ監視プラン',
        '$vuetify.コード.利用プランID.セルフ監視プラン',
      ],
      alarmType: 0,
      alarmSensorList: [],
      CONSTANTS: CONSTANTS,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU14警報確認画面センサー.警報確認センサー'),
        from: '',
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU14警報確認画面センサー.C0001'),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 警報画像取得処理
     * @returns 警報画像
     */
    getNotificationImage() {
      switch (this.alarmType) {
        case 1:
          return require('@/assets/images/icon/alarms/alarm_1.svg');
        case 2:
          return require('@/assets/images/icon/alarms/alarm_2.svg');
        case 3:
          return require('@/assets/images/icon/alarms/alarm_3.svg');
        case 4:
          return require('@/assets/images/icon/alarms/alarm_4.svg');
        case 5:
          return require('@/assets/images/icon/alarms/alarm_5.svg');
        case 6:
          return require('@/assets/images/icon/alarms/alarm_6.svg');
        case 7:
          return require('@/assets/images/icon/alarms/alarm_7.svg');
        case 8:
          return require('@/assets/images/icon/alarms/alarm_8.svg');
      }
    },
    /**
     * 警報名取得処理
     * @returns 警報名
     */
    getNotificationTitle() {
      switch (this.alarmType) {
        case 1:
          return '$vuetify.FECU14警報確認画面センサー.警報名.侵入';
        case 2:
          return '$vuetify.FECU14警報確認画面センサー.警報名.非常救急';
        case 3:
          return '$vuetify.FECU14警報確認画面センサー.警報名.火災';
        case 4:
          return '$vuetify.FECU14警報確認画面センサー.警報名.ガス';
        case 5:
          return '$vuetify.FECU14警報確認画面センサー.警報名.ライフリズム';
        case 6:
          return '$vuetify.FECU14警報確認画面センサー.警報名.電池';
        case 7:
          return '$vuetify.FECU14警報確認画面センサー.警報名.機器異常';
        case 8:
          return '$vuetify.FECU14警報確認画面センサー.警報名.設備';
      }
    },
    /**
     * 警報確認詳細データ取得（侵入以外）(APP_CU9916)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1401: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 1,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };

            this.panelTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.対象地区',
              typeIsBefore: true,
            };
            this.displayAreaList[0].text =
              this.planCode[apiData.contentsInfo.displayDistrictInfo.usagePlan];
            this.displayAreaList[1].text = apiData.contentsInfo.displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text =
              apiData.contentsInfo.displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU14警報確認画面センサー.対象地区詳細表示領域.メイン地区'
                : apiData.contentsInfo.displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text =
              apiData.contentsInfo.displayDistrictInfo.districtSplitName;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9915: async function (params) {
      this.$_setLoading(true);

      let apiData = '';
      let method = 'post';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1401: {
          //         alarmSensorList: [
          //           {
          //             alarmSensorNumber: "1",
          //             serviceType: 1,
          //             alarmSensorName: "玄関火災センサー",
          //             alarmSensorStatus: 0,
          //           },
          //           {
          //             alarmSensorNumber: "2",
          //             serviceType: 1,
          //             alarmSensorName: "キッチン火災センサー",
          //             alarmSensorStatus: 1,
          //           },
          //           {
          //             alarmSensorNumber: "3",
          //             serviceType: 1,
          //             alarmSensorName: "リビング火災センサー",
          //             alarmSensorStatus: 0,
          //           },
          //           {
          //             alarmSensorNumber: "4",
          //             serviceType: 1,
          //             alarmSensorName: "寝室火災センサー",
          //             alarmSensorStatus: 1,
          //           },
          //         ],
          //       },
          //     },
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            let alarmSensorList = [];
            apiData.contentsInfo.commandExecutionResult.app_cu1401.alarmSensorList.forEach(
              function (alarmSensor) {
                alarmSensorList.push({
                  id: alarmSensor.alarmSensorNumber,
                  securityAreaName: alarmSensor.alarmSensorName,
                  isSFRStatus: alarmSensor.alarmSensorStatus == 0 ? true : false,
                  getStatus: true,
                });
              }
            );
            alarmSensorList.sort((a, b) => a.id - b.id);
            this.alarmSensorList = alarmSensorList;
          } else {
            // ブラウザバック時は表示しない
            if (this.$route.name === this.$options.name) {
              this.$_securityUnitExecutionResultDialog(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
          }
        })
        .finally(() => {
          // ブラウザバック時に遷移先で Loading が途切れるのを回避
          if (this.$route.name === this.$options.name) {
            this.$_setLoading(false);
          }
        });

      return apiData;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    switch (this.$store.state.displayType) {
      case 2:
        this.alarmType = 2;
        break;
      case 3:
        this.alarmType = 3;
        break;
      case 4:
        this.alarmType = 4;
        break;
      case 5:
        this.alarmType = 5;
        break;
      case 6:
        this.alarmType = 6;
        break;
      case 7:
        this.alarmType = 7;
        break;
      case 8:
        this.alarmType = 8;
        break;
      default:
        this.$router.replace('/alermConfirmation');
        break;
    }

    let param = '/api/sensorWarningConfirmation/getDetailDataExceptIntrusion';
    // let param = "post";

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
      alarmType: this.alarmType,
    };

    let method = 'post';
    // APP_CU1401
    let apiData = await this.APP_CU1401(param, queries, method);

    if (typeof apiData.contentsInfo !== 'undefined') {
      let params = {
        token: queries.token,
        terminalInfo: queries.terminalInfo,
        sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.sendCommandKey,
        apiId: 7,
        alarmType: this.alarmType,
        districtSplitNumber: '',
        securityAreaId: '',
      };
      await this.APP_CO9915(params);
    }
  },
};
